export default __webpack_public_path__ + "static/media/addRef.d0435c33.svg";